import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useOverlayContext, useStore } from '~/contexts';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { usePreviewDraft } from '~/hooks/usePreviewDraft';
import { selectors } from '~/store/state-selectors';
import { navigateForRow } from './useRecentAgreementNavigation.utils';
export function useRecentAgreementNavigation() {
    const history = useHistory();
    const overlayContext = useOverlayContext();
    const worksAt = useStore(selectors.user.business);
    const { contactsMap, sampleContact } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const { previewDraft } = usePreviewDraft({
        sampleContact,
        contactsMap
    });
    return useMemo(()=>(row)=>()=>navigateForRow(row, history, overlayContext, previewDraft), [
        overlayContext,
        previewDraft
    ]);
}
